import { ref } from "vue";

const addDilemmaBottomSheetOpen = ref(false);

export function useDilemmaManagement() {
  function openAddDilemmaBottomSheet() {
    addDilemmaBottomSheetOpen.value = true;
  }

  function closeAddDilemmaBottomSheet() {
    addDilemmaBottomSheetOpen.value = false;
  }

  return {
    addDilemmaBottomSheetOpen,
    openAddDilemmaBottomSheet,
    closeAddDilemmaBottomSheet,
  };
}
